import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-custom-source',
  templateUrl: './help-add-custom-source.component.html',
  styleUrls: ['./help-add-custom-source.component.scss']
})
export class HelpAddCustomSourceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
